/**
 * metaPlacement.js - slot issues for a Meta SDK-bidding win whose placement chain breaks.
 * Twin: proxy-server/lifecycle/metaPlacement.js (pinned by metaPlacementParity.test.js).
 * Fallback only: Lifecycle renders the proxy's answer whenever the proxy responds.
 *
 * ctx = { session, packs }; session is resolveSessionMapping(rows), packs the App Pack map
 * (api/appPacks.js getPacks()). See the proxy file for the contract. Pure, never throws.
 */

import { metaAdRequestFor } from './metaTestMode';
import { placementChain, packForIu } from './sdkBiddingPlacements';
import { selectMapping, msidFromUrl, BUYER_ADAPTER_CLASSES } from './sdkBiddingMapping';

export { placementChain };

function urlParam(url, name) {
  const u = String(url || '');
  const q = u.includes('?') ? u.slice(u.indexOf('?') + 1) : '';
  try { return new URLSearchParams(q).get(name); } catch { return null; }
}

function platformOfUrl(url) {
  const js = urlParam(url, 'js') || '';
  if (/^afma-sdk-i-/i.test(js)) return 'ios';
  if (/^afma-sdk-a-/i.test(js)) return 'android';
  return null;
}

function isMetaWin(gamRow) {
  const ex = gamRow && gamRow.validData && gamRow.validData.expanded;
  const adapter = ex && typeof ex === 'object' ? ex.adapter : null;
  return typeof adapter === 'string' && BUYER_ADAPTER_CLASSES.meta.includes(adapter);
}

export function metaPlacementIssues(gamRow, sdkRows, ctx) {
  try {
    if (!gamRow || typeof gamRow !== 'object' || gamRow.captureSource === 'logcat') return [];
    if (!isMetaWin(gamRow)) return [];
    const c = ctx && typeof ctx === 'object' ? ctx : {};
    const url = String(gamRow.url || '');
    const unit = (gamRow.validData && gamRow.validData.adUnit) || urlParam(url, 'iu') || '';

    const mapping = selectMapping(c.session, msidFromUrl(url)).mapping || null;
    const pack = packForIu(c.packs, unit);
    const report = pack && pack.metaPlacementReport && typeof pack.metaPlacementReport === 'object' ? pack.metaPlacementReport : null;
    const platform = (mapping && mapping.platform) || platformOfUrl(url);
    const ids = pack && pack.identity && pack.identity.metaAppIds && typeof pack.identity.metaAppIds === 'object' ? pack.identity.metaAppIds : null;
    const packMetaAppId = ids && platform && ids[platform] ? ids[platform] : null;

    const chain = placementChain(gamRow, metaAdRequestFor(gamRow, sdkRows), { mapping, report, packMetaAppId, platform, unit });
    return chain && Array.isArray(chain.issues) ? chain.issues : [];
  } catch { return []; }
}
